<template>
  <el-scrollbar wrap-class="post-to-box">
    <Loading v-if="loading" class="static" />
    <div class="post-to-tabs" v-if="!loading && store.state.user_data?.is_motom_internal_user">
      <span :class="['tab-item', { active: activeTab === 'add' }]" @click="switchTab('add')">Add</span>
      <span
        :class="['tab-item', { active: activeTab === 'exclude', disabled: !hasAddSelection }]"
        @click="switchTab('exclude')"
        >Exclude</span
      >
    </div>
    <div class="select-top-box" v-if="!loading && activeTab === 'add'">
      <div class="line-box">
        <div class="label-line">
          <label>Account type</label>
        </div>
        <div class="input-line account-type-line" :class="{ 'has-value': accountType }">
          <el-select v-model="accountType" placeholder="Select" :disabled="clickAll">
            <el-option v-for="opt in accountTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
          </el-select>
          <svg-icon v-if="accountType" name="close-circle" class="account-type-clear" @click.stop="accountType = ''" />
        </div>
      </div>

      <div class="line-box">
        <div class="label-line">
          <label>Select creators</label>
          <Checkbox
            :checked="clickAll"
            :label_text="`All(${totalCount})`"
            :no_show_label="true"
            @click="clickAll = !clickAll"
          />
        </div>
        <div class="input-line">
          <el-select
            filterable
            remote
            :remote-method="searchCreators"
            :loading="searchLoading"
            :disabled="clickAll"
            placeholder="Search name"
            reserve-keyword
            :remote-show-suffix="true"
            popper-class="creator-remote-dropdown"
            @visible-change="onDropdownVisible"
          >
          
            <el-option
              v-for="item in searchResults"
              :key="item.id"
              :label="item.name"
              v-show="!isPicked(item)"
              placeholder="Search name"
              :value="item.id"
              @click="pickCreator(item)"
              class="creator-item"
            >
              <figure><img :src="item.avatar ? item.avatar : UserImg" /></figure>
              <span v-if="item.first_name && item.last_name && (item.first_name + ' ' + item.last_name) !== item.name">{{ item.first_name }} {{ item.last_name }} ({{ item.name }})</span>
              <span v-else>{{ item.name }}</span>
            </el-option>
            <div v-if="loadingMore && !searchLoading" class="creator-loadmore">
              <span class="spinner"></span>Loading...
            </div>
            <template #loading>
              <div class="creator-loadmore">
                <span class="spinner"></span>Loading...
              </div>
            </template>
          </el-select>
        </div>
      </div>

      <div class="line-box">
        <div class="label-line">
          <label>Select tags</label>
        </div>
        <div class="input-line">
          <el-select filterable placeholder="Select" :disabled="clickAll">
            <el-option
              v-for="(item, index) in groupList.every((e) => e.pick) ? [] : groupList"
              :key="item.value"
              :label="item.name"
              v-show="!item.pick"
              :value="item.id"
              @click="pickGroup(item, true)"
            />
          </el-select>
        </div>
      </div>
    </div>
    <div class="select-bottom-box" v-if="activeTab === 'add' && (pickedCreators.length > 0 || groupList.some((item) => item.pick))">
      <div class="shadow-box" v-if="clickAll"></div>
      <h3 class="title">Added ({{ displayCount }})</h3>
      <el-collapse v-model="activeNames">
        <el-collapse-item title="Individuals" name="1" v-if="pickedCreators.length > 0 && type === 'all'">
          <div class="add-line" v-for="(item, index) in pickedCreators" :key="index">
            <figure><img :src="item.avatar ? item.avatar : UserImg" /></figure>
            <div class="name">
              <p class="bold">{{ item.name }}</p>
              <p>{{ item.email }}</p>
            </div>
            <svg-icon class="stop-svg" name="stop" @click="removeCreator(item)" />
          </div>
        </el-collapse-item>

        <!-- 9338 New -->
        <el-collapse-item title="Individuals" name="1" v-if="pickedCreators.length > 0 && type === 'tag'">
          <Table :style="'--top: 0px'">
            <template #head>
              <tr>
                <th><span>Creator</span></th>
                <th><span>Creator tag</span></th>
                <th>
                  <span><svg-icon class="stop-svg-2" name="stop" /></span>
                </th>
              </tr>
            </template>
            <template #body>
              <tr v-for="(item, index) in pickedCreators" :key="index">
                <td>{{ item.name }}</td>
                <td class="tags-list-box">
                  <Badage :class="['tag-item-box']" :value="item.email" :show_tippy="true"></Badage>
                </td>
                <td><svg-icon class="stop-svg" name="stop" @click="removeCreator(item)" /></td>
              </tr>
            </template>
          </Table>
        </el-collapse-item>

        <el-collapse-item title="Tags" name="2" v-if="groupList.some((item) => item.pick)">
          <div class="add-line" v-for="(item, index) in groupList" :key="index" v-show="item.pick">
            <i class="group-icon"><svg-icon name="users-2" /></i>
            <div class="name">
              <p>{{ item.name }}</p>
            </div>
            <el-button size="mimi" @click="checkGroupCreators(item)">
              <svg-icon name="users" />
              {{ item.creator_count }}
            </el-button>
            <svg-icon class="stop-svg" name="stop" @click="removeGroup(item)" />
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>

    <!-- Exclude tab -->
    <div class="select-top-box" v-if="!loading && activeTab === 'exclude'">
      <div class="line-box">
        <div class="label-line">
          <label>Individual creators</label>
        </div>
        <div class="input-line">
          <!-- Add picks / tag members are always listed; "All" or an account type merges in the full audience from the remote search (de-duped) -->
          <el-select
            filterable
            remote
            :remote-method="searchExcludeCreators"
            :loading="excludeSearchLoading"
            placeholder="Search name"
            reserve-keyword
            :remote-show-suffix="true"
            popper-class="exclude-creator-dropdown"
            @visible-change="onExcludeDropdownVisible"
          >
            <el-option
              v-for="item in excludeDisplayList"
              :key="item.id"
              :label="item.name"
              v-show="!isExcluded(item)"
              :value="item.id"
              @click="pickExcludedCreator(item)"
              class="creator-item"
            >
              <figure><img :src="item.avatar ? item.avatar : UserImg" /></figure>
              <span v-if="item.first_name && item.last_name && (item.first_name + ' ' + item.last_name) !== item.name">{{ item.first_name }} {{ item.last_name }} ({{ item.name }})</span>
              <span v-else>{{ item.name }}</span>
            </el-option>
            <div v-if="excludeLoadingMore && !excludeSearchLoading" class="creator-loadmore">
              <span class="spinner"></span>Loading...
            </div>
            <template #loading>
              <div class="creator-loadmore">
                <span class="spinner"></span>Loading...
              </div>
            </template>
          </el-select>
        </div>
      </div>

      <div class="line-box">
        <div class="label-line">
          <label>
            Select tag
            <tippy content="Creators with the selected tag won't be able to view this announcement." class="question">
              <svg-icon name="question" />
            </tippy>
          </label>
        </div>
        <div class="input-line">
          <el-select filterable placeholder="Select">
            <el-option
              v-for="(item, index) in groupList.every((e) => e.exclude) ? [] : groupList"
              :key="item.value"
              :label="item.name"
              v-show="!item.exclude"
              :value="item.id"
              @click="pickExcludeTag(item, true)"
            />
          </el-select>
        </div>
      </div>
    </div>

    <div
      class="select-bottom-box"
      v-if="activeTab === 'exclude' && (excludedCreators.length > 0 || groupList.some((item) => item.exclude))"
    >
      <h3 class="title">Excluded ({{ excludedCount }})</h3>
      <el-collapse v-model="excludeActiveNames">
        <el-collapse-item title="Individuals" name="1" v-if="excludedCreators.length > 0">
          <div class="add-line" v-for="(item, index) in excludedCreators" :key="index">
            <figure><img :src="item.avatar ? item.avatar : UserImg" /></figure>
            <div class="name">
              <p class="bold">{{ item.name }}</p>
              <p>{{ item.email }}</p>
            </div>
            <svg-icon class="stop-svg" name="stop" @click="removeExcludedCreator(item)" />
          </div>
        </el-collapse-item>

        <el-collapse-item title="Groups" name="2" v-if="groupList.some((item) => item.exclude)">
          <div class="add-line" v-for="(item, index) in groupList" :key="index" v-show="item.exclude">
            <i class="group-icon"><svg-icon name="users-2" /></i>
            <div class="name">
              <p>{{ item.name }}</p>
            </div>
            <el-button size="mimi" @click="checkGroupCreators(item)">
              <svg-icon name="users" />
              {{ item.creator_count }}
            </el-button>
            <svg-icon class="stop-svg" name="stop" @click="removeExcludeTag(item)" />
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>

    <div class="btn-row" v-if="!loading">
      <el-button @click="emit('close')">Cancel</el-button>
      <el-button type="primary" @click="save()">Save</el-button>
    </div>
  </el-scrollbar>

  <el-dialog
    title="Remove from announcement?"
    width="400"
    v-model="removeDialog"
    :show-close="false"
    @close="removeDialog = false"
    class="alert-dialog"
  >
    <p>This creator or {{ type === 'all' ? 'group' : 'tags' }} will not be able to view this announcement.</p>
    <div class="btn-row" style="padding-top: 24px">
      <el-button @click="removeDialog = false">Cancel</el-button>
      <el-button type="primary" @click="handleRemove()">Yes</el-button>
    </div>
  </el-dialog>

  <!-- group list dialog -->
  <el-dialog title="Tag Group" width="600" v-model="groupDialog" @close="groupDialog = false" class="group-dialog">
    <Search
      @onenter="searchGroupCreator"
      :placeholder_text="'Search name'"
      :disabled="openGroupListValue.length === 0"
      v-if="!dialog_loading"
    />
    <el-scrollbar>
      <Loading class="static" v-if="dialog_loading" />
      <div class="add-line" v-for="(item, index) in openGroupListValue" :key="index">
        <figure><img :src="item.avatar ? item.avatar : UserImg" /></figure>
        <div class="name">
          <p>{{ item.name }}</p>
          <p>{{ item.email }}</p>
        </div>
      </div>
    </el-scrollbar>
  </el-dialog>
</template>
<script setup>
import { ref, computed, watch, onMounted, nextTick, getCurrentInstance } from 'vue';
import { ElButton, ElSelect, ElOption, ElCollapse, ElCollapseItem, ElScrollbar, ElDialog } from 'element-plus';
import Checkbox from '@/components/ui/Checkbox.vue';
import UserImg from '@/assets/images/user.png';
import Loading from '@/components/ui/Loading.vue';
import Search from '@/components/ui/Search.vue';
import Table from '@/components/ui/Table.vue';
import Badage from '@/components/ui/Badage.vue';
import store from '@/store/index.js';

const props = defineProps({
  creators: {
    type: Array,
    required: true,
  },
  group: {
    type: Array,
    required: true,
  },
  click_all: {
    type: Array,
    required: true,
  },
  list: {
    type: Object,
    required: true,
  },
  type: {
    type: String,
    default: 'all', //all or tag
  },
  account_type: {
    type: String,
    default: '',
  },
  exclude: {
    type: Object,
    default: () => ({ creator: [], tag: [] }),
  },
});
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const emit = defineEmits(['close']);
const clickAll = ref(true);
const removeDialog = ref(false);
const groupDialog = ref(false);
const openGroupListValue = ref([]);
const openGroupListValueOrgin = ref([]);
const pickedCreators = ref([]); //selected creators
const searchResults = ref([]); //paginated dropdown options returned from the ajax search
const searchLoading = ref(false); //first-page / search loading (bound to el-select)
const loadingMore = ref(false); //a request (first page or next page) is in flight
const keyword = ref(''); //current search keyword
const currentPage = ref(0); //last loaded page
const lastPage = ref(1); //total page count of the current query
const totalCount = ref(0); //total number of creators (when no keyword), used for All(N)
const PER_PAGE = 50;
const groupList = ref([]);
let searchTimer = null;
let searchSeq = 0;
let loadedKeyword = null; //keyword whose first page has been requested (null = nothing yet)

const handleRemoveValue = ref({
  type: 1, //1:creator,2:group
  item: {},
});

const loading = ref(false);
const dialog_loading = ref(false);
const count = ref(0);
const activeNames = ref(['1', '2']);
//when "All" is selected show the full creator count, otherwise the de-duplicated picked count
const displayCount = computed(() => (clickAll.value ? totalCount.value : count.value));

//+++++++++++++++++++++++++++++++++++++
// Exclude tab (UI only — API pending)
//+++++++++++++++++++++++++++++++++++++
const activeTab = ref('add'); //'add' | 'exclude'
const excludedCreators = ref([]); //creators excluded from this announcement
const excludeActiveNames = ref(['1', '2']);
const accountType = ref(''); //Add-tab audience filter
const accountTypeOptions = [
  { label: 'Storefront', value: 'storefront' },
  { label: 'Links', value: 'linkonly' },
];
//selecting "All" targets every creator, so the account type and any explicit Add picks
//(individual creators / tags) are redundant — clear them and disable those fields
watch(clickAll, (val) => {
  if (val) {
    accountType.value = '';
    pickedCreators.value = [];
    groupList.value.forEach((item) => {
      item.pick = false;
    });
  }
});
//account type is part of the unique-count params, so recompute when it changes (except in "All" mode)
watch(accountType, () => {
  if (!clickAll.value) countUser();
});
//pool of creators that can be excluded: those picked in Add + members of the picked tags
const excludeCreatorPool = ref([]);
const tagCreatorsCache = ref({}); //group_id -> creator list, to avoid refetching
//remote search state used when an Account type is selected (paginated /get-creator-list)
const excludeSearchResults = ref([]);
const excludeSearchLoading = ref(false);
const excludeLoadingMore = ref(false);
const excludeKeyword = ref('');
const excludeCurrentPage = ref(0);
const excludeLastPage = ref(1);
let excludeSearchSeq = 0;
let excludeLoadedKeyword = null;
let excludeSearchTimer = null;
//Exclude tab is only usable once something has been selected in Add
const hasAddSelection = computed(
  () =>
    clickAll.value ||
    !!accountType.value ||
    pickedCreators.value.length > 0 ||
    groupList.value.some((item) => item.pick)
);
//the exclude list pulls from the remote /get-creator-list when the Add selection is the whole
//audience: "All" (every creator) or an Account type (Storefront/Links). For explicit creator/tag
//picks the local pool is enough.
const useRemoteExcludeSearch = computed(() => clickAll.value || !!accountType.value);
//list shown in the Individual creators dropdown: the local pool (Add picks + tag members) filtered
//by the keyword on the front end, merged with the remote search results, de-duplicated by id
const excludeDisplayList = computed(() => {
  const map = new Map();
  const kw = excludeKeyword.value.trim().toLowerCase();
  excludeCreatorPool.value.forEach((c) => {
    if (!kw || (c.name && c.name.toLowerCase().includes(kw))) map.set(c.id, c);
  });
  excludeSearchResults.value.forEach((c) => {
    if (!map.has(c.id)) map.set(c.id, c);
  });
  return Array.from(map.values());
});
//local tally until the exclude API provides a unique count
const excludedCount = computed(
  () => excludedCreators.value.length + groupList.value.filter((item) => item.exclude).length
);
//+++++++++++++++++++++++++++++++++++++
// Methods
//+++++++++++++++++++++++++++++++++++++
const isPicked = (val) => {
  return pickedCreators.value.some((item) => item.id === val.id);
};

//fetch a page of creators via /announcement/get-creator-list?name=xxx&page=x&per_page=50
//reset = true  -> first page of a new query (replaces the list)
//reset = false -> next page appended to the list (infinite scroll)
const fetchCreators = async (reset) => {
  //for "load more": skip if already loading or no more pages
  if (!reset && (loadingMore.value || currentPage.value >= lastPage.value)) return;
  const seq = ++searchSeq;
  const page = reset ? 1 : currentPage.value + 1;
  loadingMore.value = true;
  if (reset) {
    searchLoading.value = true;
    loadedKeyword = keyword.value; //mark before awaiting so a focus/click can't trigger a duplicate
  }
  try {
    const params = { page, per_page: PER_PAGE };
    if (keyword.value) params.name = keyword.value;
    const response = await ajax.get('/announcement/get-creator-list', { params });
    //only apply the latest request's result to avoid out-of-order responses
    if (seq !== searchSeq) return;
    const data = response.data.data ?? {};
    const list = (data.data ?? []).map((e) => ({ ...e, name: e.name ?? 'No Name People' }));
    searchResults.value = reset ? list : [...searchResults.value, ...list];
    currentPage.value = data.current_page ?? page;
    lastPage.value = data.last_page ?? page;
    //the unfiltered total is the full creator count, used for the All(N) label
    if (!keyword.value) totalCount.value = data.total ?? totalCount.value;
  } catch (error) {
    if (seq === searchSeq && reset) searchResults.value = [];
  } finally {
    if (seq === searchSeq) {
      loadingMore.value = false;
      searchLoading.value = false;
    }
  }
};

//debounced remote search; empty keyword loads the first page of all creators
const searchCreators = (query) => {
  if (clickAll.value) return;
  clearTimeout(searchTimer);
  const trimmed = (query ?? '').trim();
  //same keyword already requested -> skip (avoids the duplicate request on focus/click)
  if (trimmed === loadedKeyword) return;
  searchTimer = setTimeout(() => {
    keyword.value = trimmed;
    fetchCreators(true);
  }, 500);
};

//bind the dropdown scroll listener once it is rendered, for infinite scroll
const onDropdownVisible = async (visible) => {
  if (!visible) return;
  await nextTick();
  const wrap = document.querySelector('.creator-remote-dropdown .el-select-dropdown__wrap');
  if (wrap && !wrap.dataset.loadmoreBound) {
    wrap.dataset.loadmoreBound = '1';
    wrap.addEventListener('scroll', onDropdownScroll);
  }
};

const onDropdownScroll = (event) => {
  if (clickAll.value) return;
  const el = event.target;
  if (el.scrollHeight - el.scrollTop - el.clientHeight <= 2) {
    fetchCreators(false);
  }
};

const pickCreator = (val) => {
  if (!isPicked(val)) {
    pickedCreators.value.push({ ...val, name: val.name ?? 'No Name People' });
  }
  countUser();
};

const pickGroup = (val, handle) => {
  groupList.value.forEach((item) => {
    if (item.id === val.id) {
      item.pick = handle;
    }
  });
  countUser();
};

//--- Exclude tab handlers ---
//switch tabs; entering Exclude (when allowed) prepares the creator source for the current Add selections
const switchTab = (tab) => {
  if (tab === 'exclude') {
    if (!hasAddSelection.value) return;
    excludeKeyword.value = '';
    buildExcludeCreatorPool(); //Add picks + tag members are always part of the list
    if (useRemoteExcludeSearch.value) {
      resetExcludeSearch(); //"All" / account-type selection -> merge in the full audience from the API
    } else {
      excludeSearchResults.value = []; //explicit creator/tag picks -> local pool only
    }
  }
  activeTab.value = tab;
};

//reset and load the first page of the remote exclude search
const resetExcludeSearch = () => {
  excludeKeyword.value = '';
  excludeLoadedKeyword = null;
  excludeSearchResults.value = [];
  excludeCurrentPage.value = 0;
  excludeLastPage.value = 1;
  fetchExcludeCreators(true);
};

//paginated fetch from /get-creator-list, filtered by account_type (Storefront/Links)
const fetchExcludeCreators = async (reset) => {
  if (!reset && (excludeLoadingMore.value || excludeCurrentPage.value >= excludeLastPage.value)) return;
  const seq = ++excludeSearchSeq;
  const page = reset ? 1 : excludeCurrentPage.value + 1;
  excludeLoadingMore.value = true;
  if (reset) {
    excludeSearchLoading.value = true;
    excludeLoadedKeyword = excludeKeyword.value;
  }
  try {
    const params = { page, per_page: PER_PAGE };
    if (excludeKeyword.value) params.name = excludeKeyword.value;
    if (accountType.value) params.account_type = accountType.value;
    const excludedUserIds = excludedCreators.value.map((c) => c.id);
    if (excludedUserIds.length) params.excluded_user_ids = excludedUserIds;
    const response = await ajax.get('/announcement/get-creator-list', { params });
    if (seq !== excludeSearchSeq) return;
    const data = response.data.data ?? {};
    const list = (data.data ?? []).map((e) => ({ ...e, name: e.name ?? 'No Name People' }));
    excludeSearchResults.value = reset ? list : [...excludeSearchResults.value, ...list];
    excludeCurrentPage.value = data.current_page ?? page;
    excludeLastPage.value = data.last_page ?? page;
  } catch (error) {
    if (seq === excludeSearchSeq && reset) excludeSearchResults.value = [];
  } finally {
    if (seq === excludeSearchSeq) {
      excludeLoadingMore.value = false;
      excludeSearchLoading.value = false;
    }
  }
};

//debounced search: the keyword filters the local pool on the front end and, when an account type
//is selected, also drives the remote /get-creator-list query (results are merged + de-duped)
const searchExcludeCreators = (query) => {
  clearTimeout(excludeSearchTimer);
  const trimmed = (query ?? '').trim();
  excludeSearchTimer = setTimeout(() => {
    excludeKeyword.value = trimmed;
    if (useRemoteExcludeSearch.value && trimmed !== excludeLoadedKeyword) {
      fetchExcludeCreators(true);
    }
  }, 500);
};

//bind the infinite-scroll listener for the exclude dropdown
const onExcludeDropdownVisible = async (visible) => {
  if (!visible) return;
  await nextTick();
  const wrap = document.querySelector('.exclude-creator-dropdown .el-select-dropdown__wrap');
  if (wrap && !wrap.dataset.loadmoreBound) {
    wrap.dataset.loadmoreBound = '1';
    wrap.addEventListener('scroll', onExcludeDropdownScroll);
  }
};

const onExcludeDropdownScroll = (event) => {
  if (!useRemoteExcludeSearch.value) return; //only the remote (All / account-type) results are paginated
  const el = event.target;
  if (el.scrollHeight - el.scrollTop - el.clientHeight <= 2) {
    fetchExcludeCreators(false);
  }
};

//gather the creators that can be excluded: Add-tab picks + members of each picked tag
const buildExcludeCreatorPool = async () => {
  const map = new Map();
  pickedCreators.value.forEach((c) => map.set(c.id, { ...c, name: c.name ?? 'No Name People' }));
  const pickedTags = groupList.value.filter((g) => g.pick);
  for (const tag of pickedTags) {
    let creators = tagCreatorsCache.value[tag.id];
    if (!creators) {
      try {
        const res = await ajax.get('/announcement/get-group-creator-list', { params: { group_id: tag.id } });
        creators = res.data.data ?? [];
      } catch (error) {
        creators = [];
      }
      tagCreatorsCache.value[tag.id] = creators;
    }
    creators.forEach((c) => {
      if (!map.has(c.id)) map.set(c.id, { ...c, name: c.name ?? 'No Name People' });
    });
  }
  excludeCreatorPool.value = Array.from(map.values());
};

const isExcluded = (val) => excludedCreators.value.some((item) => item.id === val.id);

const pickExcludedCreator = (val) => {
  if (!isExcluded(val)) {
    excludedCreators.value.push({ ...val, name: val.name ?? 'No Name People' });
    countUser(); //exclusions affect the unique recipient count
  }
};

const pickExcludeTag = (val, handle) => {
  groupList.value.forEach((item) => {
    if (item.id === val.id) item.exclude = handle;
  });
  countUser();
};

//removing an exclusion just restores access, so no confirm dialog is needed
const removeExcludedCreator = (val) => {
  excludedCreators.value = excludedCreators.value.filter((item) => item.id !== val.id);
  countUser();
};

const removeExcludeTag = (val) => {
  pickExcludeTag(val, false);
};

const removeCreator = (val) => {
  handleRemoveValue.value = { type: 1, item: val };
  removeDialog.value = true;
};

const removeGroup = (val) => {
  handleRemoveValue.value = { type: 2, item: val };
  removeDialog.value = true;
};

const handleRemove = () => {
  if (handleRemoveValue.value.type === 1) {
    pickedCreators.value = pickedCreators.value.filter((item) => item.id !== handleRemoveValue.value.item.id);
    countUser();
  } else {
    pickGroup(handleRemoveValue.value.item, false);
  }
  handleRemoveValue.value.item = {};
  removeDialog.value = false;
};
const save = () => {
  //excluded creators/tags passed back to the parent for the create/update payload
  const exclude = {
    creator: excludedCreators.value,
    tag: groupList.value.filter((item) => item.exclude),
  };
  if (clickAll.value) {
    emit('close', {
      type: 'all',
      data: { creator: [], group: [], count: totalCount.value, accountType: accountType.value, exclude },
    });
  } else {
    emit('close', {
      type: 'pick',
      data: {
        creator: pickedCreators.value,
        group: groupList.value.filter((item) => item.pick),
        count: count.value,
        accountType: accountType.value,
        exclude,
      },
    });
  }
};

const startFunction = () => {
  clickAll.value = props.click_all;
  accountType.value = props.click_all ? '' : (props.account_type ?? ''); //"All" leaves account type empty
  //restore previously excluded creators
  excludedCreators.value = (props.exclude?.creator ?? []).map((e) => ({ ...e, name: e.name ?? 'No Name People' }));
  count.value = props.list.count ?? 0; //non-all count is refreshed by countUser; all uses totalCount
  getDropApi();
  fetchCreators(true); //preload the first page (also fills totalCount for the All(N) label)
};

const getDropApi = async () => {
  //seed the already-selected creators (the dropdown list is fetched via API on remote search)
  pickedCreators.value = props.creators.map((e) => ({ ...e, name: e.name ?? 'No Name People' }));
  groupList.value = props.list.groupList;
  const excludedTagIds = (props.exclude?.tag ?? []).map((t) => t.id);
  groupList.value.forEach((e) => {
    e.name = `${e.tag} (${e.creator_count})`;
    e.pick = props.group.some((gro) => gro.id === e.id);
    e.exclude = excludedTagIds.includes(e.id); //restore previously excluded tags
  });
};

//get creators of a group
const checkGroupCreators = async (item) => {
  openGroupListValue.value = [];
  groupDialog.value = true;
  dialog_loading.value = true;
  const params = { group_id: item.id };
  const response = await ajax.get(`/announcement/get-group-creator-list`, { params });
  const data = response.data.data;
  openGroupListValueOrgin.value = data;
  openGroupListValue.value = data;
  dialog_loading.value = false;
};

const searchGroupCreator = (keyword) => {
  openGroupListValue.value = openGroupListValueOrgin.value.filter(
    (e) => e.name && e.name.toLowerCase().includes(keyword.toLowerCase())
  );
};

const countUser = async () => {
  try {
    let params = {
      group_ids: groupList.value.filter((item) => item.pick).map((item) => item.id),
      creator_ids: pickedCreators.value.map((item) => item.id),
      excluded_tag_ids: groupList.value.filter((item) => item.exclude).map((item) => item.id),
      excluded_user_ids: excludedCreators.value.map((item) => item.id),
    };
    if (accountType.value) params.account_type = accountType.value;
    const response = await ajax.get(`/announcement/get-unique-creator-count`, { params });
    count.value = response.data.data ? response.data.data : 0;
  } catch (error) {
    count.value = 0;
  }
};
//+++++++++++++++++++++
//mounted
//+++++++++++++++++++++
onMounted(() => {
  startFunction();
});
</script>
<style lang="scss">
.post-to-box {
  position: relative;

  .post-to-tabs {
    display: flex;
    align-items: center;
    gap: 24px;
    border-bottom: solid 1px var(--border);

    .tab-item {
      position: relative;
      padding: 8px 0;
      font: var(--medium-14);
      color: var(--text-secondary);
      cursor: pointer;

      &.active {
        color: var(--text-primary);

        &::after {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          bottom: -1px;
          height: 2px;
          background-color: var(--text-primary);
        }
      }

      &.disabled {
        color: var(--text-disabled, var(--border));
        cursor: not-allowed;
      }
    }
  }

  .label-line label .question {
    display: inline-flex;
    align-items: center;

    .svg-icon {
      width: 16px;
      height: 16px;
      fill: var(--text-secondary);
    }
  }

  .el-scrollbar {
    max-height: 60vh;
  }

  .el-scrollbar__view {
    max-height: 60vh;
    padding-right: 16px;
  }

  .line-box {
    display: grid;

    .label-line {
      display: flex;
      align-items: center;
      margin: 16px 0;
      gap: 8px;

      label {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 8px;
        font: var(--medium-16);
        color: var(--text-primary);

        .svg-icon {
          cursor: pointer;
          width: 16px;
          height: 16px;
          fill: var(--text-default);
        }
      }

      .ui-checkbox {
        margin: 0;
        font: var(--medium-14);
        color: var(--text-primary);
      }
    }

    .input-line {
      display: grid;

      .el-select {
        width: 100%;
      }
    }
  }

  .select-top-box {
    padding-top: 8px;
  }

  .account-type-line {
    position: relative;

    //有值时由常驻清除按钮取代默认的下拉箭头
    &.has-value .el-select__caret {
      display: none;
    }

    .account-type-clear {
      position: absolute;
      top: 50%;
      right: 12px;
      transform: translateY(-50%);
      width: 14px;
      height: 14px;
      cursor: pointer;
      fill: var(--text-secondary);
      z-index: 2;

      &:hover {
        fill: var(--text-primary);
      }
    }
  }

  .select-bottom-box {
    border-top: solid 1px var(--border);
    margin-top: 32px;
    padding: 16px 0;
    position: relative;

    .shadow-box {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: var(--black-100);
      opacity: 0.3;
      z-index: 1;
      width: 100%;
      height: 100%;
    }

    h3 {
      font: var(--medium-16);
      color: var(--text-primary);
    }

    .el-collapse {
      border: none;

      .el-collapse-item__header {
        font: var(--font);
        font-size: 12px;
        color: var(--text-primary);
      }

      .el-collapse-item__content {
        display: grid;
        gap: 8px;
      }
    }
  }

  .btn-row {
    position: sticky;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 8px 0 4px;
    background-color: var(--white);
    z-index: 2;
    width: 100%;
  }
}

.add-line {
  display: flex;
  align-items: center;
  gap: 8px;

  figure {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    border: solid 1px var(--border);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  .group-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: solid 1px var(--border);
    display: flex;
    align-items: center;
    justify-content: center;

    .svg-icon {
      width: 16px;
      height: 16px;
      fill: var(--Text-default);
    }
  }

  .name {
    flex: 1;

    p {
      &:first-child {
        font: var(--medium-12);
        color: var(--text-primary);
      }

      &:last-child {
        font-size: 12px;
        color: var(--text-secondary);
      }
    }
  }

  .el-button--mimi span {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .svg-icon {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  .stop-svg {
    fill: var(--red);
  }
}

.ui-table {
  .svg-icon {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  .stop-svg {
    fill: var(--red);
  }

  .stop-svg-2 {
    fill: var(--text-secondary);
  }

  .tags-list-box {
    display: flex;
    align-items: center;
    padding: 4px;
    gap: 6px;

    .my-badges-iden {
      display: flex;
      align-items: center;
      border-radius: 6px;

      span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 120px;
      }
    }
  }
}

.group-dialog {
  .el-scrollbar__view {
    display: grid;
    gap: 8px;
  }

  .ui-search-input {
    .input {
      max-width: unset;
    }

    margin: 0 0 16px 0;
  }
}

.el-select-dropdown {
  .creator-item {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }

    figure {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: solid 1px var(--border);
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }
  }
}

.creator-remote-dropdown,
.exclude-creator-dropdown {
  .creator-loadmore {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 8px;
    font-size: 12px;
    color: var(--text-secondary);

    .spinner {
      width: 14px;
      height: 14px;
      border: 2px solid var(--border);
      border-top-color: var(--text-secondary);
      border-radius: 50%;
      animation: creator-loadmore-spin 0.6s linear infinite;
    }
  }
}

@keyframes creator-loadmore-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
